import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

// INTERFACES
import { IWarehouse as IWarehouseV1 } from 'app/core/locations/store/locations.model';

import { IWarehouse } from '../../../../shared/interfaces/location-warehouse.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

export interface ILocationsResponse {
  data :IWarehouseV1[];

  // For some reason this endpoint doesn't wrap these in an object under the
  // `meta` property, but puts them at the top level?  If this ever changes,
  // this interface can be removed and we can use `ILumResponse<IWarehouseV1[]>`
  // instead.  [calvin]
  current_page :number;
  first_page_url :string;
  from :number;
  last_page :number;
  last_page_url :string;
  next_page_url ?:string;
  path :string;
  per_page :number;
  prev_page_url ?:string;
  to :number;
  total :number;
}

@Injectable({
  providedIn: 'root',
})
export class LocationWarehouseApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _warehouses = new BehaviorSubject<IWarehouse[]>(
    <IWarehouse[]>[],
  );

  loading$ = this._loading.asObservable();
  warehouses$ = this._warehouses.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  fetchWarehouses(params :{ [param :string] :string | string[] }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/locations`, {
        params,
      })
      .subscribe({
        next: (response) => {
          if (response.length) {
            this._warehouses.next(response);
            this._loading.next(false);
          }
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getWarehouses(
    params ?:HttpParams | HttpParamsHash,
  ) :Observable<ILocationsResponse> {
    params = {
      parent_id: 0,
      ...params,
    };

    return this.getLocations(params);
  }

  getLocations(
    params ?:HttpParams | HttpParamsHash,
  ) :Observable<ILocationsResponse> {
    return this.apiService
      .get(`${this.environment.urlV1}/locations`, { params })
      .pipe();
  }
}
